import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import { en, ru, de, es, tr, hr } from 'vuetify/src/locale'

Vue.use(Vuetify)

const MY_ICONS = {
  complete: 'fal fa-check',
  cancel: 'fal fa-times-circle',
  close: 'fal fa-times',
  delete: 'fal fa-times', // delete (e.g. v-chip close)
  clear: 'fal fa-times', // delete (e.g. v-chip close)
  success: 'fal fa-check-circle',
  info: 'fal fa-info-circle',
  warning: 'fal fa-exclamation',
  error: 'fal fa-exclamation-triangle',
  prev: 'fal fa-chevron-left',
  next: 'fal fa-chevron-right',
  checkboxOn: 'fa fa-check-square',
  checkboxOff: 'fal fa-square', // note 'far'
  checkboxIndeterminate: 'fal fa-minus-square',
  delimiter: 'fal fa-circle', // for carousel
  sort: 'fal fa-sort-up',
  expand: 'fal fa-chevron-down',
  menu: 'fal fa-bars',
  subgroup: 'fal fa-caret-down',
  dropdown: 'fal fa-caret-down',
  radioOn: 'far fa-dot-circle',
  radioOff: 'far fa-circle',
  edit: 'fal fa-edit',
  ratingEmpty: 'far fa-star',
  ratingFull: 'fal fa-star',
  ratingHalf: 'fal fa-star-half',
  loading: 'fal fa-sync',
  first: 'fal fa-step-backward',
  last: 'fal fa-step-forward',
  unfold: 'fal fa-arrows-alt-v',
  file: 'fal fa-paperclip',
  plus: 'fal fa-plus',
  minus: 'fal fa-minus'
}

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#BC291C',
        secondary: '#5e2c7e',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#2196F3',
        secondary: '#424242',
        accent: '#FF4081',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  },
  icons: {
    iconfont: 'fa',
    values: MY_ICONS
  },
  lang: {
    locales: { en, ru, de, es, tr, hr },
    current: 'en'
  }
})
